export class DriversResultItem {
	strength: number;
	volume: number;
	displayName: string;
	identifier?: string;
	rawStrength: number;
	impactRank: number;
	nodePath?: string;
	[key: string]: any;
}